import { render, staticRenderFns } from "./editClassManage.vue?vue&type=template&id=568544e2&scoped=true"
import script from "./editClassManage.vue?vue&type=script&lang=js"
export * from "./editClassManage.vue?vue&type=script&lang=js"
import style0 from "./editClassManage.vue?vue&type=style&index=0&id=568544e2&prod&lang=less"
import style1 from "./editClassManage.vue?vue&type=style&index=1&id=568544e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568544e2",
  null
  
)

export default component.exports